import { styled } from '@mui/system';
import { Button, CircularProgress } from '@mui/material';

// Styled Button Component
export const StyledButton = styled(Button)(({ theme, hasError, variant }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  width: 'fit-content',
  textWrap: 'nowrap',
  backgroundColor: variant ? undefined : 'black',
  border: hasError ? `1px solid ${theme.palette.error.main}` : 'none',

  // Button text styles
  color: variant ? undefined : hasError ? theme.palette.error.main : theme.palette.text.secondary || 'blue',
  textTransform: 'none', // Prevent MUI Button default uppercase

  '&:hover': {
    backgroundColor: variant ? undefined : 'black',
    color: variant ? undefined : hasError ? theme.palette.error.main : theme.palette.text.secondary || 'blue',
  },
  '& .MuiButton-startIcon': {
    margin: 0, // Reset default margins for icon wrapper
  },
  // Parent background variation
  '&.use-parent-background': {
    justifyContent: 'flex-start',
    padding: '0px',
    width: '100%',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

export const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));
